<div class="si-delete-icon">
  <div (click)="onClickIcon($event)">
    <span pTooltip="{{tooltip | translate}}" tooltipPosition="{{tooltipPosition}}">
      <i class="{{icon}} pointer {{iconClass}}"></i>
    </span>
  </div>
  <si-generic-dialog [displayDialog]="displayDialog"
                     [dialogTitle]="titleDialog"
                     [dialogTitleStyleClass]="titleDialogStyleClass"
                     [dialogText]="textDialog"
                     [button1Text]="button1Text"
                     [button1Class]="button1Class"
                     [button2Text]="button2Text"
                     [button2Class]="button2Class"
                     (updateButton1Change)="onClickCloseDialog(false)"
                     (updateButton2Change)="onClickCloseDialog(true)"
                     (displayDialogChange)="onChangeDisplayDialog($event)"
    ></si-generic-dialog>
</div>

